import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Current type to show
export enum CLOCK_TYPE {
  HOURS = 1,
  MINUTES = 2
}

export type TimeFormat = 24;

export interface ITime {
  hour: number;
  minute: number;
  format: TimeFormat;
}

@Component({
    selector: 'time-picker',
    styleUrls: ['./time-picker.component.scss'],
    templateUrl: './time-picker.component.html',
    standalone: false
})
export class TimePickerComponent implements OnChanges, OnInit {

  @Input() public userTime: ITime;
  @Output() public userTimeChange: EventEmitter<ITime> = new EventEmitter();
  @Input() public currentView: CLOCK_TYPE = CLOCK_TYPE.HOURS;

  hour = 0;
  minute = 0;

  color = null;

  public steps = new Array<number>();
  public selectedTimePart;

  constructor(public dialogRef: MatDialogRef<TimePickerComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    if (!this.data) {
      this.userTime = { hour: 0, minute: 0, format: 24 };
    } else {
      this.userTime = { hour: +this.data.split(':')[0], minute: +this.data.split(':')[1], format: 24 };
      this.hour = this.userTime.hour;
      this.minute = this.userTime.minute;
    }
  }

  ngOnChanges() {
    this.setupUI();
  }

  public getPointerStyle(mode: string) {

    let divider = 1;
    switch (this.currentView) {

      case CLOCK_TYPE.HOURS:
        divider = 12;
        break;

      case CLOCK_TYPE.MINUTES:
        divider = 60;
        break;
    }

    let degrees = 0;
    if (this.currentView === CLOCK_TYPE.HOURS) {
      degrees = Math.round(this.userTime.hour % 12 * (360 / divider)) - 180;
    } else {
      degrees = Math.round(this.userTime.minute * (360 / divider)) - 180;
    }

    const style = {
      '-webkit-transform': 'rotate(' + degrees + 'deg)',
      '-ms-transform': 'rotate(' + degrees + 'deg)',
      'transform': 'rotate(' + degrees + 'deg)'
    };

    if (this.currentView === CLOCK_TYPE.HOURS && ((mode === 'outer' && this.userTime.hour > 12) || (mode === 'inner' && this.userTime.hour <= 12))) {
      style['opacity'] = 0;
    }

    return style;
  }

  save() {
    this.dialogRef.close(this.userTime);
  }

  cancel() {
    this.dialogRef.close(null);
  }

  private setupUI() {
    this.steps = new Array<number>();

    switch (this.currentView) {

      case CLOCK_TYPE.HOURS:

        for (let i = 1; i <= this.userTime.format; i++) {
          this.steps.push(i);
          this.selectedTimePart = this.userTime.hour || 0;

          if (this.selectedTimePart > this.userTime.format) {

            this.selectedTimePart -= this.userTime.format;
          }
        }
        break;

      case CLOCK_TYPE.MINUTES:

        for (let i = 5; i <= 55; i += 5) {

          this.steps.push(i);
        }
        this.steps.push(0);
        this.selectedTimePart = this.userTime.minute || 0;
        break;
    }
  }

  public getTimeValueClass(step: number, index: number) {
    let classes;
    if (this.currentView === CLOCK_TYPE.HOURS) {
      classes = 'w-clock-step w-clock-deg' + (30 * (step % 12));
    } else {
      classes = 'w-clock-step w-clock-deg' + (30 * (step / 5));
    }

    if (this.selectedTimePart === step) {
      classes += ' mat-primary';
    }

    return classes;
  }

  public changeTimeValue(step: number) {
    if (this.currentView === CLOCK_TYPE.HOURS) {
      this.userTime.hour = step;
      this.hour = step;
      this.currentView = CLOCK_TYPE.MINUTES;
    } else {
      this.userTime.minute = step;
      this.minute = step;
      this.currentView = CLOCK_TYPE.HOURS;
    }
    this.userTimeChange.emit(this.userTime)
  }
}
